module.exports = __webpack_public_path__ + "media/backgrounds/marek-piwnicki-sIaIHalCnsM-unsplash-e0cbf492.jpg";